import { GameSettings } from '../types/game';

export const DEFAULT_SETTINGS: GameSettings = {
  maxRounds: 5,
  minDelay: 1000,
  maxDelay: 4000,
  signalTimeout: 5000,
};

export const calculateScore = (reactionTime: number): number => {
  if (reactionTime <= 200) return 100;
  if (reactionTime <= 300) return 80;
  if (reactionTime <= 400) return 60;
  if (reactionTime <= 500) return 40;
  return 20;
};

export const getRandomDelay = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const formatTime = (ms: number): string => {
  return `${ms}ms`;
};

export const generatePlayerId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};